
        <!-- Footer -->
        <footer id="footer">
            <div class="footer-content">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-3">
                            <div class="widget">

                                <div class="widget-title">Cllaj Martinique</div>
                                <!-- Footer About -->
                                <div class="single-widget footer-about widget">
                                    <div class="logo">
                                        <div class="img-logo">
                                            <a class="logo" routerLink="/">
                                                <img class="img-responsive" src="assets/images/2023/logo-mobile.png" width="auto" height="100" alt="CLLAJ Martinique logo">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="footer-widget-about-description">
                                        <h5 class="text-uppercase mb-4 font-weight-bold">Heures de réception du public</h5>
                                        <p >


                                            Lundi, mardi et jeudi : 7h30 à 13h et 14h à 16h<br>

                                            Mercredi : 7h30 à 13h<br>

                                            Vendredi : 8h à 12h30
                                        </p>
                                    </div>
                                    <div class="social">
                                        <!-- Social Icons -->
                                        <ul class="social-icons">
                                            <li><a class="facebook" href="https://www.facebook.com/CLLAJMartinique/" target="_blank"><i class="fab fa-facebook fa-2x"></i></a></li>
                                            <li><a class="twitter" href="https://twitter.com/CllajAccueil" target="_blank"><i class="fab fa-twitter fa-2x"></i></a></li>
                                            <li><a class="instagram" href="https://www.instagram.com/cllaj972/" target="_blank"><i class="fab fa-instagram fa-2x"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <!--/ End Footer About -->
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-9">
                            <div class="row">
                                <div class="col-lg-5 col-md-6">
                                    <div class="widget">
                                        <div class="widget-title">Important</div>
                                        <ul class="list">
                                            <li><a routerLink="faq">FAQ</a></li>
                                            <li><a routerLink="divers/mentions-legales">Conditions Générales d'Utilisation</a></li>
                                            <li><a routerLink="divers/protection-donnees">Protection des données</a> </li>
                                            <li><a routerLink="contact">Contact</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg-7 col-md-6">
                                    <div class="widget">
                                        <div class="widget-title">Contact</div>
                                        <div class="w-100">
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1930.4304511660762!2d-61.08308634343685!3d14.606998589798389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c6aa71d34afef47%3A0xd60584226cbdd0df!2s16%20Av.%20Condorcet%2C%20Fort-de-France%2097200%2C%20Martinique!5e0!3m2!1sfr!2sfr!4v1652882690636!5m2!1sfr!2sfr" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                        <div class="row">
                                          <div class="col-6"><ul class="address-widget-list mt-3 list-style-none">
                                            <li class="footer-mobile-number">
                                                <i class="fa fa-home"></i> 16, avenue Condorcet <br>
                                                <span class="ml-5"> 97200 Fort-de-France</span>
                                            </li>
                                            <li class="footer-mobile-number"><a routerLink="contact"><i class="fa fa-envelope-open"></i> Nous contacter</a></li>
                                            <li class="footer-mobile-number"><i class="fa fa-phone"></i> 05 96 71 28 35</li>
                                        </ul></div>
                                          <div class="col-6">
                                             <!-- photocllaj.png -->
                                        <img class="img-fluid" src="assets/images/2023/photocllaj.png" width="100%" height="auto" alt="CLLAJ Martinique logo">
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; {{annee}} Plateforme D'Clic Jeune du CLLAJ Martinique - Tous droits réservés.</div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->

